export const PREDICTIVE_PACK_ECONOMICS = 'predictive_pack_economics';
export const PREDICTIVE_PACK_ECONOMICS_DETAILS = 'predictive_pack_economics_details';
